import LogoutIcon from '@mui/icons-material/Logout';
import AppRoutes from '../router/data/app-routes';

export interface OptionType {
    name: string;
    path: string;
    icon?: JSX.Element | undefined;
}

export const appPages: OptionType[] = [];

export const userMenuOptions: OptionType[] = [
    { name: 'Logout', path: AppRoutes.logoutPath, icon: <LogoutIcon /> },
];
